<div @backdropAnimation class="backdrop" (click)="close()"></div>

<sb-scrollbox class="nav" [@inOutAnimation]="isMobile ? 'mobile' : 'desktop'">
  <sb-member-profile-nav class="sb-nav" />
</sb-scrollbox>
